module.exports = __webpack_public_path__ + "assets/Retina-BlackItalic.02f5a38f167f4ce1052076cb4838d8fb.woff2";